export function purchaseRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_PURCHASE_START":           
        case "UPDATE_PURCHASE_START":           
        case "RECEIVE_PURCHASE_START":           
        case "DELETE_PURCHASE_START":           
        case "ADD_FILES_PURCHASE_START":           
        case "LINK_PURCHASE_START":           
        case "UNLINK_PURCHASE_START":    
        case "FETCH_INIT_DATA2_START":      
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_PURCHASE_FULFILLED":           
        case "UPDATE_PURCHASE_FULFILLED":           
        case "RECEIVE_PURCHASE_FULFILLED":           
        case "DELETE_PURCHASE_FULFILLED":           
        case "ADD_FILES_PURCHASE_FULFILLED":           
        case "LINK_PURCHASE_FULFILLED":           
        case "UNLINK_PURCHASE_FULFILLED":           
        case "FETCH_INIT_DATA2_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_PURCHASE_ERROR":
        case "UPDATE_PURCHASE_ERROR":
        case "RECEIVE_PURCHASE_ERROR":
        case "DELETE_PURCHASE_ERROR":
        case "ADD_FILES_PURCHASE_ERROR":
        case "LINK_PURCHASE_ERROR":
        case "UNLINK_PURCHASE_ERROR":
        case "FETCH_INIT_DATA2_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}